import FieldProto from "../../../../fields3/proto/field-proto"
import FieldConfig from "../../../../fields3/proto/field-config";
import FieldSystemLogStatus_View from "./render/view";
import FieldSystemLogStatus_ViewSmall from "./render/view-small";

export default class FieldSystemLogStatus extends FieldProto {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Status";
        this.label      = "Status";

        _.assign(this.renderComponents,{
            view                : FieldSystemLogStatus_View,
            viewSmall           : FieldSystemLogStatus_ViewSmall
        })
    }

    getDisplayValue(value: any): any {
        return gd.const.event[value].name
    }
}